import { FC, ReactNode } from 'react';
import LinkBox, { LinkBoxProps } from '../LinkBox';
import Skeleton from './Skeleton';
import Stack from '../Stack';
import Typography from '../Typography';

export interface LinkBoxSkeletonProps extends Omit<LinkBoxProps, 'children'> {
  children?: ReactNode;
  showAvatar?: boolean;
}

const LinkBoxSkeleton: FC<LinkBoxSkeletonProps> = ({ showAvatar = true, ...props }) => {
  const { children } = props;
  const defaultChildren = (
    <>
      <Skeleton sx={{ mb: 1 }}>
        <Typography variant="subtitle1">Testovací zákazník</Typography>
      </Skeleton>
      <Skeleton />
    </>
  );

  return (
    <LinkBox
      startIcon={showAvatar ? <Skeleton variant="circular" width={35} height={35} /> : false}
      hideIcon
      {...props}
      sx={{ pointerEvents: 'none' }}
    >
      <Stack direction="column" alignItems="stretch" width="100%" marginLeft={0.5}>
        {children ?? defaultChildren}
      </Stack>
    </LinkBox>
  );
};

export default LinkBoxSkeleton;
